<template>
  <span>
    <input class="kd-form__checkbox" type="checkbox" :value="val" :id="_uid" :disabled="disabled" v-model="checked" @change='onChange' @click='onClick'/>
    <label :for="_uid">{{ label }}</label>
  </span> 
</template>

<script>
export default {
  props: [ 'val', 'value', 'label', 'disabled' ],
  data() {
    return {
      checkedProxy: false
    }
  },
  computed: {
    checked: {
      get() {
        return this.value
      },
      set(val) {
        this.checkedProxy = val
      }
    }
  },
  methods: {
    onChange(e) {
      this.$emit('input', this.checkedProxy, e)
    },
    onClick(e) {
      this.$emit('click', this.checkedProxy, e)
    }
  }
} 
</script>
